import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import messages from '@/messages/es.json';

function getValueAtPath(obj: Record<string, unknown>, path: string): unknown {
  const keys = path.split('.');
  let current: unknown = obj;
  for (const key of keys) {
    if (current === null || current === undefined) {
      return undefined;
    }
    if (typeof current !== 'object') {
      return undefined;
    }
    current = (current as Record<string, unknown>)[key];
  }
  return current;
}

export function useTranslations(namespace: string) {
  const { t } = useTranslation();

  return useMemo(() => {
    const translate = (key: string, params?: Record<string, unknown>) => {
      const fullKey = `${namespace}.${key}`;
      return t(fullKey, params as Record<string, unknown> | undefined) as string;
    };

    translate.has = (key: string) => {
      const fullKey = `${namespace}.${key}`;
      return getValueAtPath(messages, fullKey) !== undefined;
    };

    translate.raw = (key: string) => {
      const fullKey = `${namespace}.${key}`;
      return getValueAtPath(messages, fullKey);
    };

    return translate;
  }, [t, namespace]);
}
